import { Pipe, PipeTransform } from '@angular/core';
import { AccountGroupLocation } from '@vendasta/account-group';

type Address = Pick<AccountGroupLocation, 'address' | 'city' | 'state' | 'zip' | 'country'>;

// formatAddress formats address, city, state, zip, and country into a comma separated string
@Pipe({
  name: 'formatAddress',
  standalone: false,
})
export class FormatAddressPipe implements PipeTransform {
  transform(address: Address): string {
    return [
      address.address?.trim(),
      address.city?.trim(),
      address.state?.trim(),
      address.zip?.trim(),
      address.country?.trim(),
    ]
      .filter((v) => !!v)
      .join(', ');
  }
}
